import CoreLayout from '../layout/core-layout';
import App from './app';
import Login from './login';
import Logout from './logout';

export default [{
    path: '/',
    component: CoreLayout,
    routes: [
        Login,
        App,
        Logout

    ]
}];



// WEBPACK FOOTER //
// ./src/js/routes/index.js